import BusinessPartnerDistributionChainAttributes from '@albatrosdeveloper/ave-models-package/lib/schemas/business-partners/business-partners-dchain/business-partners-dchain.entity';
import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { ReactiveFormsModule, FormsModule, FormControl } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatOptionModule } from '@angular/material/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIcon, MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenav, MatSidenavContainer } from '@angular/material/sidenav';
import { MatSlideToggle } from '@angular/material/slide-toggle';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule, MatRowDef } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
import { NgLabelTemplateDirective, NgOptionTemplateDirective, NgSelectComponent } from '@ng-select/ng-select';
import DivisionAttributes from '@albatrosdeveloper/ave-models-package/lib/schemas/configurations/division/division.entity';
import { DivisionService } from 'app/modules/components/configuration/division/division.service.service';
import CompanyAttributes from '@albatrosdeveloper/ave-models-package/lib/schemas/configurations/company/company.entity';
import { CompanyService } from 'app/modules/components/configuration/company/company.service.service';
import SalesOrganizationAttributes from '@albatrosdeveloper/ave-models-package/lib/schemas/configurations/sales-organization/sales-organization.entity';
import ChannelAttributes from '@albatrosdeveloper/ave-models-package/lib/schemas/configurations/channel/channel.entity';
import PriceListAttributes from '@albatrosdeveloper/ave-models-package/lib/schemas/masters/price-list/price-list.entity';
import { PriceListService } from 'app/modules/components/master/price-list/price-list.service';
import { ChannelService } from 'app/modules/components/configuration/channel/channel.component.service';
import { SalesOrganizationService } from 'app/modules/components/configuration/sales-organization/sales-organization.component.service';
import BusinessPartnerAddressAttributes from '@albatrosdeveloper/ave-models-package/lib/schemas/business-partners/business-partners-contact/business-partners-contact.entity';
import { SalesOfficeService } from 'app/modules/components/configuration/sales-office/sales-office.service';
import { RouteAreaService } from 'app/modules/components/routing/route-area/route-area.service';
import { SubRouteService } from 'app/modules/components/routing/sub-routes/sub-route.service';
import { ICreateBusinessPartnerChain } from '../distribution-chain-modal/interfaces/create-distribution-chain.interface';
import SalesOfficeAttributes from '@albatrosdeveloper/ave-models-package/lib/schemas/configurations/sales-office/sales-office.entity';
import RouteAreaAttributes from '@albatrosdeveloper/ave-models-package/lib/schemas/routing/route-area/route-area.entity';
import { AddressTypeAttributes, LocationFiveAttributes, LocationFourAttributes, LocationOneAttributes, LocationSixAttributes, LocationThreeAttributes, LocationTwoAttributes, ShortBusinessPartnerAddressRouteAttributes, SubRouteAttributes } from '@albatrosdeveloper/ave-models-package';
import { ICreateBusinessPartnerAddress } from './interfaces/create-business-partner-address.interface';
import AddressAttributes from '@albatrosdeveloper/ave-models-package/lib/schemas/common/embedded/address/address.entity';
import { LocationOneService } from 'app/modules/components/locations/location-one/location-one.service.service';
import { AddressTypeService } from 'app/modules/components/common/address-type/address-type.service.service';
import { LocationTwoService } from 'app/modules/components/locations/location-two/location-two.service';
import { LocationThreeService } from 'app/modules/components/locations/location-three/location-three.service';
import { LocationFourService } from 'app/modules/components/locations/location-four/location-four.service';
import { LocationFiveService } from 'app/modules/components/locations/location-five/location-five.service';
import { LocationSixService } from 'app/modules/components/locations/location-six/location-six.service';
import { BusinessPartnerAddressService } from './business-partner-address.component.service';
import { CompanyAddressService } from 'app/modules/components/configuration/company/company-address-modal/company-address.service';
import { HandlerMessageService } from 'app/common/services/handler-error/handler-message.service';
import RouteAttributes from '@albatrosdeveloper/ave-models-package/src/schemas/routing/route/route.entity';
import { combineLatest, Observable, ReplaySubject, Subject, take, takeUntil } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { getCode } from 'app/utils/method';
import { BusinessPartnerService } from '../business-partner.service';
import ShortRouteAttributes from '@albatrosdeveloper/ave-models-package/lib/schemas/routing/route/short-route/route.short.entity';
import { RouteService } from 'app/modules/components/routing/route/route.service';
import { MatCheckboxModule } from '@angular/material/checkbox';


@Component({
  selector: 'app-add-business-partner-address-modal',
  styleUrl: './business-partner-address.component.scss',
  templateUrl: './business-partner-address.component.html',
  standalone: true,
  imports: [
    CommonModule,
    MatTableModule,
    MatDialogModule,
    MatButtonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatSortModule,
    MatPaginatorModule,
    MatIcon,
    MatSlideToggle,
    MatSelectModule,
    MatOptionModule,
    MatTooltipModule,
    MatExpansionModule,
    MatMenuModule,
    MatButtonModule,
    MatIconModule,
    MatRowDef,
    MatSidenav,
    MatSidenavContainer,
    FormsModule,
    NgLabelTemplateDirective,
    NgOptionTemplateDirective,
    NgSelectComponent,
    MatSelectModule,
    MatTabsModule,
    NgxMatSelectSearchModule,
    MatCheckboxModule

  ],
})
export class AddBusinessPartnerAddressComponent {
  getCode = getCode;
  currentCreateBusinessPartnerAddress: ICreateBusinessPartnerAddress = this.initializeCreateBusinessPartnerAddress();
  currentUpdateBusinessPartnerAddress: AddressAttributes | undefined;

  addressList: AddressTypeAttributes[] = [];
  locationOneList: LocationOneAttributes[] = [];
  locationTwoList: LocationTwoAttributes[] = [];
  locationThreeList: LocationThreeAttributes[] = [];
  locationFourList: LocationFourAttributes[] = [];
  locationFiveList: LocationFiveAttributes[] = [];
  locationSixList: LocationSixAttributes[] = [];
  routeList: ShortRouteAttributes[] = [];

  latitudError: boolean = false;
  longitudError: boolean = false;
  latitudInput: string = '';

  isEditMode: boolean;
  bpId: string;

  /** control for the selected route for multi-selection */
  public routeMultiCtrl: FormControl<ShortBusinessPartnerAddressRouteAttributes[]> = new FormControl<
    RouteAttributes[]
  >([]);

  /** control for the MatSelect filter keyword multi-selection */
  public routeMultiFilterCtrl: FormControl<string> = new FormControl<string>(
    ""
  );

  sortedRoutes$: Observable<ShortBusinessPartnerAddressRouteAttributes[]>;

  /** list of route filtered by search keyword */
  public filteredRoutes: ReplaySubject<ShortBusinessPartnerAddressRouteAttributes[]> = new ReplaySubject<
    RouteAttributes[]
  >(1);

  /** local copy of filtered route to help set the toggle all checkbox state */
  protected filteredRouteCache: ShortBusinessPartnerAddressRouteAttributes[] = [];

  /** flags to set the toggle all checkbox state */
  isIndeterminate = false;
  isChecked = false;


  protected _onDestroy = new Subject<void>();
  constructor(
    private readonly addressService: BusinessPartnerAddressService,
    private readonly addressCompanyService: CompanyAddressService,
    private readonly addressTypeService: AddressTypeService,
    private readonly locationOneService: LocationOneService,
    private readonly locationTwoService: LocationTwoService,
    private readonly locationThreeService: LocationThreeService,
    private readonly locationFourService: LocationFourService,
    private readonly locationFiveService: LocationFiveService,
    private readonly locationSixService: LocationSixService,
    private readonly businessService: BusinessPartnerService,
    private readonly routeService: RouteService,
    private readonly handlerMessage: HandlerMessageService,
    public dialogRef: MatDialogRef<AddBusinessPartnerAddressComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any // Optional: if you want to pass data
  ) {
    this.bpId = data?.bpId || data?.companyId;

    // Se considera edición si existen otros datos aparte de bp y bpId
    this.isEditMode = !!data && Object.keys(data).some(key => !['bp', 'bpId', 'company', 'companyId'].includes(key));


    // this.isEditMode = !!data; 
    if (this.isEditMode) {
      this.currentCreateBusinessPartnerAddress = {
        ...data,
        locationOneId: data?.locationOne?._id ? data.locationOne._id.toString() : null,
        locationTwoId: data?.locationTwo?._id ? data.locationTwo._id.toString() : null,
        locationThreeId: data?.locationThree?._id ? data.locationThree._id.toString() : null,
        locationFourId: data?.locationFour?._id ? data.locationFour._id.toString() : null,
        locationFiveId: data?.locatioFive?._id ? data.locatioFive._id.toString() : null,
        locationSixId: data?.locationSix?._id ? data.locationSix._id.toString() : null,
        addresstypeId: data.type._id,
        routeIds: data.routes ? data.routes.map((route) => ({
          id: route._id.toString(),
          isPrincipal: route.isPrincipal || false
        })) : []
      };

      if (this.currentCreateBusinessPartnerAddress.locationOneId) {
        this.changeLocationOne(data.locationOne)
      }

      if (this.currentCreateBusinessPartnerAddress.locationTwoId) {
        this.changeLocationTwo(data.locationTwo)
      }

       if (this.currentCreateBusinessPartnerAddress.locationThreeId) {
        this.changeLocationFour(data.locationThree)
      }
    }
  }


  ngAfterViewInit(): void {
    // this.setupPaginationAndSorting();
    this.fetchAllLocationOne();
    this.fetchAllLocationTwo(null);
    this.fetchAllAddressType();
    this.fetchAllLocationThree(null);
    this.fetchAllLocationFour(null);
    this.fetchAllRoutes();
  }

  private fetchAllRoutes(): void {
    this.routeService.findToComboBox().subscribe({
      next: (res) => {
        this.routeList = res.data;
        this.filteredRoutes.next(this.routeList);
        this.filteredRoutes.pipe(take(1)).subscribe((routes) => {

          const routesWithPrincipalFlag = routes.map(route => {
            const matchedRoute = this.currentCreateBusinessPartnerAddress.routeIds?.find(
              r => r.id === route._id.toString()
            );
            return {
              ...route,
              isPrincipal: matchedRoute ? matchedRoute.isPrincipal : false
            };
          });

          const selectedRoutes = routesWithPrincipalFlag.filter((route: any) =>
            this.currentCreateBusinessPartnerAddress.routeIds?.some(
              (r: { id: string; isPrincipal: boolean }) => r.id === route._id.toString()
            )
          );

          // Inicializar sortedRoutes$ antes de usarlo
          this.sortedRoutes$ = combineLatest([
            this.filteredRoutes,
            this.routeMultiCtrl.valueChanges.pipe(startWith(selectedRoutes))
          ]).pipe(
            map(([routes, selected]) => {
              return [...routes].sort((a, b) => {
                const aSelected = selected.some(r => r._id === a._id);
                const bSelected = selected.some(r => r._id === b._id);
                return aSelected === bSelected ? 0 : aSelected ? -1 : 1;
              });
            })
          );

          this.filteredRoutes.next(routesWithPrincipalFlag);
          this.routeMultiCtrl.setValue(selectedRoutes);
        });

        // listen for search field value changes
        this.routeMultiFilterCtrl.valueChanges
          .pipe(takeUntil(this._onDestroy))
          .subscribe(() => {
            this.filterRouteMulti();
            this.setToggleAllCheckboxState();
          });
      },
      error: (err) => {
        this.handlerMessage.error({
          message: err.error.message,
          alternativeMessage: "Error al obtener ruta",
          statusCode: err.status
        });
      },
    });
  }

  protected filterRouteMulti() {
    if (!this.routeList) {
      return;
    }
    // get the search keyword
    let search = this.routeMultiFilterCtrl.value;
    if (!search) {
      this.filteredRouteCache = this.routeList;
      this.filteredRoutes.next(this.routeList);
      return;
    } else {
      search = search.toLowerCase();
    }
    // Filtrar las rutas por nombre o código
    this.filteredRouteCache = this.routeList.filter((material) => {
      const nameMatches = material.name.toLowerCase().indexOf(search) > -1;
      const codeMatches =
        material.externalKeys?.code?.toLowerCase().indexOf(search) > -1;
      return nameMatches || codeMatches; // Devolver true si coincide con el nombre o el código
    });
    this.filteredRoutes.next(this.filteredRouteCache);
  }

  toggleSelectAll(selectAllValue: boolean) {
    this.filteredRoutes
      .pipe(take(1), takeUntil(this._onDestroy))
      .subscribe((val) => {
        if (selectAllValue) {
          this.routeMultiCtrl.patchValue(val);
        } else {
          this.routeMultiCtrl.patchValue([]);
        }
      });
  }
  protected setToggleAllCheckboxState() {
    let filteredLength = 0;
    if (this.routeMultiCtrl && this.routeMultiCtrl.value) {
      this.filteredRouteCache.forEach((el) => {
        if (this.routeMultiCtrl.value.indexOf(el) > -1) {
          filteredLength++;
        }
      });
      this.isIndeterminate =
        filteredLength > 0 && filteredLength < this.filteredRouteCache.length;
      this.isChecked =
        filteredLength > 0 && filteredLength === this.filteredRouteCache.length;
    }
  }

  private fetchAllLocationOne(): void {
    this.locationOneService.findToComboBox().subscribe({
      next: (res) => {
        this.locationOneList = res.data;
      },
      error: (err) => {
        this.handlerMessage.error({
          message: err.error.message,
          alternativeMessage: "Error al obtener ubicación",
          statusCode: err.status
        });
      }
    });
  }

  async changeLocationOne(event): Promise<void> { //{ "_id", "code", "name"
    this.locationTwoList = []

    await this.fetchAllLocationTwo(event);
  }

  private fetchAllLocationTwo(country): void {
    if (!country) {
      return;
    }

    this.locationTwoService.findToComboBox(country.code).subscribe({
      next: (res) => {
        this.locationTwoList = res.data;
      },
      error: (err) => {
        this.handlerMessage.error({
          message: err.error.message,
          alternativeMessage: "Error al obtener departamento",
          statusCode: err.status
        });
      }
    });
  }

  changeLocationTwo(event): void { //{ "_id", "code", "name"
    this.locationThreeList = []

    this.fetchAllLocationThree(event)
  }

  private fetchAllLocationThree(locationTwo): void {
    if (!locationTwo) {
      return;
    }

    this.locationThreeService.findToComboBox(locationTwo.code).subscribe({
      next: (res) => {
        this.locationThreeList = res.data;
        const exists = this.locationThreeList.some(
          (dept) => String(dept._id) === this.currentCreateBusinessPartnerAddress.locationThreeId
        );

        if (!exists) {
          this.currentCreateBusinessPartnerAddress.locationThreeId = null;
        }
      },
      error: (err) => {
        this.handlerMessage.error({
          message: err.error.message,
          alternativeMessage: "Error al obtener ubicación",
          statusCode: err.status
        });
      }
    });
  }

    changeLocationFour(event): void { //{ "_id", "code", "name"
    this.locationFourList = []
    this.fetchAllLocationFour(event)
  }

private fetchAllLocationFour(locationFour: any): void {
  if (!locationFour) {
    return;
  }

  this.locationFourService.findToComboBox(locationFour.code).subscribe({
    next: (res) => {
        this.locationFourList = res.data;
        const exists = this.locationFourList.some(
          (dept) => String(dept._id) === this.currentCreateBusinessPartnerAddress.locationFourId
        );

        if (!exists) {
          this.currentCreateBusinessPartnerAddress.locationFourId = null;
        }
      },
    error: (err) => {
      this.handlerMessage.error({
        message: err.error.message,
        alternativeMessage: "Error al obtener los distritos",
        statusCode: err.status
      });
    },
  });
}


  private fetchAllLocationFive(): void {
    this.locationFiveService.findToComboBox().subscribe({
      next: (res) => {
        this.locationFiveList = res.data;
      },
      error: (err) => {
        this.handlerMessage.error({
          message: err.error.message,
          alternativeMessage: "Error al obtener ubicación",
          statusCode: err.status
        });
      }
    });
  }

  private fetchAllLocationSix(): void {
    this.locationSixService.findToComboBox().subscribe({
      next: (res) => {
        this.locationSixList = res.data;
      },
      error: (err) => {
        this.handlerMessage.error({
          message: err.error.message,
          alternativeMessage: "Error al obtener ubicación",
          statusCode: err.status
        });
      }
    });
  }

  private fetchAllAddressType(): void {
    this.addressTypeService.findToComboBox().subscribe({
      next: (res) => {
        this.addressList = res.data;
      },
      error: (err) => {
        this.handlerMessage.error({
          message: err.error.message,
          alternativeMessage: "Error al obtener tipo de dirección",
          statusCode: err.status
        });
      }
    });
  }


  private initializeCreateBusinessPartnerAddress(): ICreateBusinessPartnerAddress {
    return {
      name: '',
      address: '',
      reference: '',
      geolocationPoint: [],
      addresstypeId: '',
      isPrincipal: false,
      externalKeys: [],
      postalCode: '',
      contactName: '',
      routeIds: []
    };
  }

  validateDecimal(value: string, field: 'latitud' | 'longitud') {
    let sanitizedValue = value.replace(',', '.').trim(); 
    const decimalRegex = /^-?\d+(\.\d*)?$/;
     const isValid = decimalRegex.test(sanitizedValue);

    if (field === 'latitud') {
      this.latitudError = !isValid;
      this.latitudInput = value;
      if (isValid) {
        this.currentCreateBusinessPartnerAddress.geolocationPoint[0] = parseFloat(sanitizedValue);        
      }
    } else {
      this.longitudError = !isValid;
      this.latitudInput = value;
      if (isValid) {
        this.currentCreateBusinessPartnerAddress.geolocationPoint[1] = parseFloat(sanitizedValue);
      }
    }
  }

  isValidCoordinate(lat: number | string | null | undefined, lng: number | string | null | undefined): boolean {
    const isLatEmpty = lat == null || lat === '';
    const isLngEmpty = lng == null || lng === '';

    // Si una coordenada está vacía y la otra tiene valor, mostrar error
    if ((!isLatEmpty && isLngEmpty) || (isLatEmpty && !isLngEmpty)) {
      this.handlerMessage.warning({ message: "Debe ingresar tanto la latitud como la longitud" });
      return false;
    }

    if (isLatEmpty && isLngEmpty) {  // Si ambas están vacías, permitir continuar
      return true;
    }

    // Convertir a número si vienen como string
    const parsedLat = Number(lat); const parsedLng = Number(lng);

    // Validar que sean números válidos
    if (isNaN(parsedLat) || isNaN(parsedLng)) {
      this.handlerMessage.warning({ message: "Las coordenadas ingresadas no son válidas. Deben ser valores numéricos" });
      return false;
    }

    // Validar rangos de latitud y longitud
    const isLatValid = parsedLat >= -90 && parsedLat <= 90;
    const isLngValid = parsedLng >= -180 && parsedLng <= 180;

    if (!isLatValid || !isLngValid) {
      this.handlerMessage.warning({ message: "Las coordenadas ingresadas no son válidas. Asegúrese de que la latitud esté entre -90 y 90, y la longitud entre -180 y 180" });
      return false;
    }

    return true;
  }

  compareRoutes(r1: any, r2: any): boolean {
    return r1?._id === r2?._id;
  }

  save() {
    const lat = this.currentCreateBusinessPartnerAddress.geolocationPoint[0];
    const lng = this.currentCreateBusinessPartnerAddress.geolocationPoint[1];

    this.currentCreateBusinessPartnerAddress.routeIds = this.routeMultiCtrl.value.map(
      (rou: ShortBusinessPartnerAddressRouteAttributes) => ({
        id: rou._id.toString(),
        isPrincipal: rou.isPrincipal // o puedes establecerlo como true si es el caso
      })
    );

    if (!this.isValidCoordinate(lat, lng)) {
      return;
    }

    // Filtrar datos vacíos antes de enviarlos (los arrays vacíos sí se envían)
    const dataToSend = Object.entries(this.currentCreateBusinessPartnerAddress).reduce((acc, [key, value]) => {
      if (value !== '' && value !== null) {
        acc[key] = value;
      }
      return acc;
    }, {} as Partial<ICreateBusinessPartnerAddress>);

    // Validar si es Business Partner o Company
    const isBusinessPartner = !!this.data.bp && !!this.data.bpId;
    const isCompany = !!this.data.company && !!this.data.companyId;

    if (!isBusinessPartner && !isCompany) {
      this.handlerMessage.error({ message: "Error: No se proporcionó un ID de business partner o company" });
      return;
    }

    // Obtener ID correcto
    const entityId = isBusinessPartner ? this.data.bpId.toString() : this.data.companyId.toString();

    if (this.isEditMode) {
      // Si está en edición, usa el servicio correspondiente
      if (isBusinessPartner) {
        this.addressService.updateEmbedded(entityId, this.data._id.toString(), dataToSend)
          .subscribe({
            next: () => {
              this.handlerMessage.success({ message: "Registro actualizado con éxito" });
              this.dialogRef.close(true);
            },
            error: (err) => {
              this.handlerMessage.error({
                message: err.error.message,
                alternativeMessage: "Error al actualizar el registro",
                statusCode: err.status
              });
            },
          });
      } else {
        this.addressCompanyService.updateEmbedded(entityId, this.data._id.toString(), dataToSend)
          .subscribe({
            next: () => {
              this.handlerMessage.success({ message: "Registro actualizado con éxito" });
              this.dialogRef.close(true);
            },
            error: (err) => {
              this.handlerMessage.error({
                message: err.error.message,
                alternativeMessage: "Error al actualizar el registro",
                statusCode: err.status
              });
            },
          });
      }
    } else {
      // Si está creando, usa el servicio correspondiente
      if (isBusinessPartner) {
        this.addressService.createEmbedded(entityId, dataToSend as ICreateBusinessPartnerAddress)
          .subscribe({
            next: () => {
              this.handlerMessage.success({ message: "Registro creado con éxito" });
              this.dialogRef.close(true);
            },
            error: (err) => {
              this.handlerMessage.error({
                message: err.error.message,
                alternativeMessage: "Error al crear el registro",
                statusCode: err.status
              });
            },
          });
      } else {
        this.addressCompanyService.createEmbedded(entityId, dataToSend as ICreateBusinessPartnerAddress)
          .subscribe({
            next: () => {
              this.handlerMessage.success({ message: "Registro creado con éxito" });
              this.dialogRef.close(true);
            },
            error: (err) => {
              this.handlerMessage.error({
                message: err.error.message,
                alternativeMessage: "Error al crear el registro",
                statusCode: err.status
              });
            },
          });
      }
    }
  }

  markAsPrincipal(route: ShortBusinessPartnerAddressRouteAttributes | null) {
    const currentValue = this.routeMultiCtrl.value as ShortBusinessPartnerAddressRouteAttributes[];

    const updatedRoutes = currentValue.map(r => ({
      ...r,
      isPrincipal: route ? r._id.toString() === route._id.toString() : false
    }));

    this.routeMultiCtrl.setValue(updatedRoutes);
  }

  isPrincipalDisabled(route: ShortBusinessPartnerAddressRouteAttributes): Observable<boolean> {
    return this.filteredRoutes.pipe(
      map(routes => {
        const principalRoute = routes.find(r => r.isPrincipal);
        // Solo deshabilita si hay otra ruta principal diferente
        return !!principalRoute && principalRoute._id.toString() !== route._id.toString();
      })
    );
  }
}
